document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.querySelector('.but_btn_grid .product-form__submit, .variant-accordions, .product-add-group-to-cart'),
        stickyBar = document.querySelector('.sticky-bar');

    if (!trigger || !stickyBar) return;

    function checkSticky() {
        const boundingTrigger = trigger.getBoundingClientRect();

        const fullyBelow = boundingTrigger.top > window.innerHeight,
            fullyAbove = boundingTrigger.bottom < 0,
            notVisible = fullyBelow || fullyAbove,
            isAtBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 20;

        if (notVisible && !isAtBottom) {
            stickyBar.classList.add('show');
        } else {
            stickyBar.classList.remove('show');
        }
    }

    window.addEventListener('scroll', checkSticky);
    window.addEventListener('resize', checkSticky);

    checkSticky();

    const header = document.querySelector('sticky-header');
    const getStartedBtn = document.querySelector('#get-started');
    const qtyTarget = document.querySelector('.product-variant-picker, .variant-accordions, .color-palette-container');

    if (getStartedBtn && qtyTarget) {
        getStartedBtn.addEventListener('click', (e) => {
            e.preventDefault();

            const headerHeight = header ? header.offsetHeight : 0,
                targetPos = qtyTarget.getBoundingClientRect().top + window.scrollY,
                scrollToPos = targetPos - headerHeight;

            window.scrollTo({
                top: scrollToPos,
                behavior: 'smooth'
            });
        });
    }
});